<!--begin::Aside-->
    <div class="sidebar d-flex flex-column bg-primary" [@collapseToggle]="menuIsCollapsed ? 'collapse' : 'full'">
    
        <a *ngIf="!this.menuIsCollapsed; else collapsedIcon" [routerLink]="[ '' ]" class="align-self-center mt-12">
            <img alt="Logo" src="assets/svg/master_vantagem_logo.svg" class="mv-logo logo theme-light-show" />
        </a>
        <ng-template #collapsedIcon>
            <a #collapsedIcon [routerLink]="[ '' ]" class="align-self-center mt-12">
                <img alt="Logo" src="assets/images/logos/logomv_negativo.png" class="mv-logo collapsed logo theme-light-show" />
            </a>
        </ng-template>
        


        <div class="d-flex flex-column">
            <div class="symbol symbol-80px mb-4 align-self-center">
                <img [src]="avatarSafeUrl ?? 'assets/media/avatars/blank.png'" alt="" />
            </div>
            <ng-container *ngIf="user">
                <div class="text-center" [@sidebarTextCollapse]="this.menuIsCollapsed ? 'collapseText' : 'fullText'">
                    <!--begin::Username-->
                    <a [routerLink]="['/profile']" class="text-white fs-4 fw-bolder"> {{ user.firstName + ' ' + user.lastName }}</a>
                    <!--end::Username-->
                    <!--begin::Description-->
                    <span class="text-white fw-semibold d-block fs-7 mb-1">{{ user.email }}</span>
                    <!--end::Description-->
                </div>
            </ng-container>
            
        </div>
        

        <div [ngClass]="!this.menuIsCollapsed ? 'px-5' : ''">
            <div *ngFor="let menu of menus" data-kt-menu-trigger="click" class="menu-item menu-accordion" [class.show]="menu.show">
                <!--begin:Menu link-->
                <a class="menu-link" (click)="openSubMenu(menu, true );">
                    <span class="menu-icon text-white">
                        <i class="fa-duotone fa-solid fs-3" [class]="'fa-' + menu.icon"></i>
                    </span>
                    <span class="menu-title text-gray-300">{{ (!this.menuIsCollapsed ? menu.title : (menu.collapsedTitle ?? menu.title)) | translate }}</span>
                    <span *ngIf="(menu.children?.length ?? 0) > 0" class="menu-arrow" [class.menu-arrow-open]="menu.show" (click)="openSubMenu(menu, false );$event.stopImmediatePropagation()"></span>
                </a>
                <!--end:Menu link-->
                <!--begin:Menu sub-->
                <div class="px-5 submenu-wrapper" [@submenuAnimation]="menu.show ? 'open' : 'closed'">
                    <!--begin:Menu item-->
                    <div *ngFor="let child of menu.children" class="menu-item" [@childItemAnimation]="menu.show ? 'visible' : 'hidden'">
                        <!--begin:Menu link-->
                        <a *ngIf="!child.disabled; else disabledChild" class="menu-link" [routerLink]="[child.url]">
                            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span><span
                                class="menu-title text-white text-gray-400">{{ child.title | translate }}</span>
                        </a>
                        <ng-template #disabledChild>
                            <a class="menu-link disabled" [matTooltip]="('IN_DEVELOPMENT' | translate)" matTooltipPosition="right">
                                <span class="menu-bullet"><span class="bullet bullet-dot"></span></span><span
                                    class="menu-title text-white text-gray-400">{{ child.title | translate }}</span>
                            </a>
                        </ng-template>
                        <!--end:Menu link-->
                    </div>
                </div>
                <!--end:Menu sub-->
            </div>
        </div>
        
        <div class="btn btn-sm btn-primary border-1 border-solid sidebar-collapse" (click)="triggerMenuFoldOrUnfold()">
            <i *ngIf="!menuIsCollapsed" class="fa fa-angles-left"></i>
            <i *ngIf="menuIsCollapsed" class="fa fa-angles-right"></i>
        </div>

    </div>

<!--end::Aside-->
